// Module
var code = "<div class=\"u-sizeFullWidth ui-grid-cell-contents\">\n    <div class=\"u-flex u-flexMiddle u-flexSpaced\">\n        <coupon-redemption-code-status redemptions=\"row.entity.Redemptions\" max-redemptions=\"row.entity.MaxRedemptions\"></coupon-redemption-code-status>\n    </div>\n</div>\n";
// Exports
module.exports = code;